<template>
  <div>
    <nav class="navbar navbar-expand-lg navigation fixed-top sticky" id="navbar">
      <div class="container">
        <a class="navbar-logo" href="/">
          <img src="@/assets/images/logo-dark.png" alt height="28" class="logo logo-dark"/>
          <img src="@/assets/images/logo-light.png" alt height="28" class="logo logo-light"/>
        </a>
        <ul class="navbar-nav ml-auto">
          <li class="nav-item">
            <a class="nav-link" href="/">{{ entidade.ent_nome }}</a>
          </li>
        </ul>
        <div class="collapse navbar-collapse" id="topnav-menu-content">
          <ul class="navbar-nav ml-auto" id="topnav-menu">
            <li class="nav-item">
              <a class="nav-link" href="/">Início</a>
            </li>
            <li v-show="menu" class="nav-item">
              <a class="nav-link" v-scroll-to="'#features'" href="javascript: void(0);">Tecnologia</a>
            </li>
            <li v-show="menu" class="nav-item">
              <a class="nav-link" v-scroll-to="'#documentation'" href="javascript: void(0);">Documentação</a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    <div v-scroll-spy>
      <slot/>
      <footer class="landing-footer">
        <div class="container">
          <div class="row justify-content-between">
            <div class="col-md-5">
              <div class="mb-4">
                <img src="@/assets/images/logo-light.png" alt height="38"/>
              </div>
              <p class="mb-2">{{ entidade.ent_nome }}</p>
              <p class="mb-2">CNPJ: {{ entidade.ent_cnpj | VMask('##.###.###/####-##') }}</p>
              <p class="mb-2">Telefone: {{ entidade.ent_telefone1 | VMask('(##) #### ####?#') }}</p>
              <p>
                {{ entidade.ent_endereco }} {{ entidade.ent_numero }}, {{ entidade.ent_bairro }}<br>
                {{ entidade.mun_nome }} - {{ entidade.mun_uf }}<br>
                CEP: {{ entidade.ent_cep | VMask('##.###-###') }}
              </p>
            </div>
            <div class="col-md-4 text-right">
              <div class="mb-4">
                <img src="http://www.dattasystem.com.br/portal/img/logo.png"/>
              </div>
              <p class="mb-2">{{ new Date().getFullYear() }} © DattaNFSe</p>
              <p class="mb-2">Desenvolvimento</p>
              <p class="mb-2">Datta System Tecnologia</p>
            </div>
          </div>
        </div>
        <!-- end container -->
      </footer>
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";
import {authMethods} from "@/state/helpers";
import {getIndex} from "@/api/core";

export default {
  name: "base-account",
  props: {
    menu: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      entidade:{}
    };
  },
  created() {
    this.getEntidade();
    window.addEventListener("scroll", this.windowScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.windowScroll);
  },
  computed: {
    ...mapState("authfack", ["status"]),
  },
  methods: {
    ...authMethods,
    windowScroll() {
      const navbar = document.getElementById("navbar");
      if (
          document.body.scrollTop >= 50 ||
          document.documentElement.scrollTop >= 50
      ) {
        navbar.classList.add("nav-sticky");
      } else {
        navbar.classList.remove("nav-sticky");
      }
    },
    toggleMenu() {
      document.getElementById("topnav-menu-content").classList.toggle("show");
    },
    getEntidade() {
      getIndex().then(response => {
        if (response.status) {
          this.entidade = response.dados.parametros;
        }
      }).catch(error => {
        console.log(error)
      })
    },
  }
}
</script>

<style scoped>

</style>